export default {"src":"/org/_next/static/media/email.67b57ea3.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};